import { get } from "../services/api";

export const setPath = (path) => ({
    type: "SET_PATH",
    path,
});

export const setLayout = (id) => ({
    type: "SET_LAYOUT_ID",
    id,
});

export const setPathLayout = (data) => ({
    type: "SET_PATH_LAYOUT",
    data,
});

export const initHeader = (data) => ({
    type: "INIT_HEADER",
    data,
});

export const setHeaderLoading = (status) => ({
    type: "SET_HEADER_LOADING",
    status,
});

export const setFooterLoading = (status) => ({
    type: "SET_FOOTER_LOADING",
    status,
});

export const initRoute = (data) => ({
    type: "INIT_ROUTES",
    data,
});

export const getRoutes = () => {
    return (dispatch) => {
        return get("get/routes").then(({ data }) => {
            if (data.length) {
                dispatch(initRoute(data));
            }
            return data;
        });
    };
};

export const setSetting = (data) => ({
    type: "SET_SETTING",
    data,
});

export const getSetting = () => {
    return (dispatch) => {
        return get("get/setting").then(({ data }) => {
            if (Object.keys(data).length) {
                dispatch(setSetting(data));
            }
            return data;
        });
    };
};

export const initFooter = (data) => ({
    type: "INIT_FOOTER",
    data,
});

export const getFooterSection = () => {
    return (dispatch) => {
        return get("get/footer_navigation").then(({ data }) => {
            if (Object.keys(data).length) {
                dispatch(initFooter(data));
                dispatch(setFooterLoading(false));
            } else {
                dispatch(setFooterLoading(false));
            }
            return data;
        });
    };
};

export const getHeaderSection = () => {
    return (dispatch) => {
        return get("get/header").then(({ data }) => {
            if (Object.keys(data).length) {
                dispatch(initHeader(data));
                dispatch(setHeaderLoading(false));
            } else {
                dispatch(setHeaderLoading(false));
            }
            return data;
        });
    };
};

export const setHeaderNavigation = (data) => ({
    type: "INIT_HEADERMENU",
    data,
});

export const getHeaderNavigation = (parms) => {
    return (dispatch) => {
        return get("get/navigation", parms).then(({ data }) => {
            if (data.length) {
                dispatch(setHeaderNavigation(data));
            }
            return data;
        });
    };
};

export const setTopNavigation = (data) => ({
    type: "INIT_TOPMENU",
    data,
});

export const getTopNavigation = (parms) => {
    return (dispatch) => {
        return get("get/navigation", parms).then(({ data }) => {
            if (data.length) {
                dispatch(setTopNavigation(data));
            }
            return data;
        });
    };
};
